import React, { Component } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { Button, FormControl, FormGroup } from 'modules/theme';
// import { AuthBox, AuthTextBox, Links } from '../styles';
import consts from 'consts';
import { Alert } from 'modules/theme';
import APIManager from 'modules/common/apiManager';
import { apiUrl } from 'helpers/dotenv';
import { localStore } from 'helpers';
import { ControlLabel } from 'react-bootstrap';
import { AuthBox, AuthTextBox } from '../styles/main';
import { Links } from '../../../../auth/styles';
import { globalAction } from 'store/action';
import { globalStateSelector } from 'store/selector';
import { connect } from 'react-redux';

const propTypes = {
  login: PropTypes.func.isRequired,
  history: PropTypes.object
};

class LoginFormTheme extends Component {
  constructor(props) {
    super(props);

    this.mAPI = new APIManager();
    this.tURL = apiUrl;

    let isLogin = true;
    let tUserID = localStorage.getItem('USER_ID');
    if (
      tUserID === null ||
      typeof tUserID === 'undefined' ||
      tUserID === 'undefined' ||
      tUserID === ''
    ) {
      isLogin = false;
    }

    this.state = {
      userID: '',
      email: '',
      password: '',
      loginForm: isLogin
    };

    this.login = this.login.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleUserIDChange = this.handleUserIDChange.bind(this);
  }

  setForceParam(userId, url, isSecure = true) {
    let http = 'http://';
    let ws = 'ws://';
    if (isSecure) {
      http = 'https://';
      ws = 'wss://';
    }
    localStorage.setItem('USER_ID', userId);
    localStorage.setItem(
      'REACT_APP_API_SUBSCRIPTION_URL',
      `${ws}${url}/${userId}/api/`
    );
    localStorage.setItem('REACT_APP_API_URL', `${http}${url}/${userId}/api/`);
    localStorage.setItem(
      'CLOUD_APP_API_URL',
      'https://app.streamspace.ai/cloudManager'
    );
    localStorage.setItem(
      'REACT_FS_SERVER_HOST',
      `${http}${url}/${userId}/fs/api/play/`
    );
    localStorage.setItem('IS_CLOUD', false);
  }

  login(e) {
    var that = this;
    e.preventDefault();
    const { email, password } = this.state;
    const { dynamicUpdate } = this.props;
    // this.mAPI.sendPostAPI(
    //   `auth/login`,
    //   {
    //     email: email,
    //     password: password
    //   },
    //   data => {
    //     // data = {token: "",
    //     // user : { "companys" : [ { "isDeleted" : false, "status" : true, "name" : "rStream", "tenant_id" : "rStream", "region" : { "region_id" : "512dbfb5-ef7e-4212-84cd-0b41bb746424", "region_name" : "India East (Kolkata)", "region" : "in-ea-2", "endpoint" : "alpha-tenant.streamspace.ai", "protocol" : "https", "socket" : "5c0c-5-79-66-75.ngrok.io", "socketProtocol" : "http" } } ], "isDeleted" : false, "status" : true, "isSocialAcoountId" : false, "isVerified" : false, "role" : 2, "email" : "r@s.com", "userId" : "e1d23120-5462-410f-bfae-4f2bc8dd205d", "otp" : 227242, "__v" : 0, "country_code" : "+91", "mobile_number" : "9662547231", "name" : "rStream", "password" : "$2b$10$dH4dflITOcllJo2GqFT0y.QiItFqoA4z8lp36Dor6mtHX1I6DPFqG", "salt" : "$2b$10$dH4dflITOcllJo2GqFT0y." }}
    //     let token = data.token;
    //     let user = data.user;
    //     console.log(`Setting UP user...`);
    //     try {
    //       localStore.setItem('token', token);
    //     } catch (e) {
    //       console.log(e);
    //     }
    //     dynamicUpdate({ key: 'currentUser', value: user });
    //     let orgSelected = false;
    //     if( data.user && data.user.companys && data.user.companys.length == 1 ){
    //       for (let tComp of data.user.companys) {
    //         orgSelected = true;
    //         localStore.setItem('selected-tenant', tComp.tenant_id);
    //       }
    //     }
    //     console.log(`organization --> reference updated`, orgSelected, data);
    //     if( orgSelected == true ){
    //       this.props.history.push('/');
    //     } else {
    //       this.props.history.push('/organization');
    //     }
    //     // this.props.history.push("/");
    //     // window.location.href = '/';
    //   },
    //   (error, data) => {
    //     console.log(`Error:`, error);
    //     this.setState({
    //       signInLoading: false
    //     });
    //     let message = data && data.message ? data.message : "Something went Wrong"; 
    //     Alert.error(message);
    //   },
    //   'public'
    // );
  }

  handleEmailChange(e) {
    e.preventDefault();
    this.setState({ email: e.target.value });
  }

  handleUserIDChange(e) {
    e.preventDefault();
    this.setState({ userID: e.target.value });
  }

  handlePasswordChange(e) {
    e.preventDefault();
    this.setState({ password: e.target.value });
  }

  renderLoginForm() {
    const { __ } = this.context;
    return (
      <div>
        {/* <h2 style={{ marginBottom: '20px' }}>{__('Sign in')}</h2> */}
        <p>{__('')}</p>
        <form onSubmit={this.login}>
          <FormGroup>
            <ControlLabel>Work Email</ControlLabel>
            <FormControl
              type="email"
              placeholder={__('your@email.com')}
              value={this.state.email}
              required
              onChange={this.handleEmailChange}
            />
          </FormGroup>
          <FormGroup>
            <ControlLabel>Password</ControlLabel>
            <FormControl
              type="password"
              placeholder={__('Password')}
              value={this.state.password}
              required
              onChange={this.handlePasswordChange}
            />
          </FormGroup>
          <Links style={{ marginTop: '-12px', textAlign: 'end' }}>
            <Link to="/forgot-password">{__('Forgot Password?')}</Link>
          </Links>
          <div>
            {/* <Button
              btnStyle="default"
              type="submit"
              // block
              style={{ marginTop: '30px', border: '1px solid #C7C7C7' }}
            >
              Sign In
            </Button> */}
            <Button
              btnStyle="default"
              type="submit"
              block
              style={{ marginTop: '30px' }}
            >
              Sign In
            </Button>
            {/* <div className="line">
              <span> Or sign up with</span>
            </div> */}
            {/* <Button
              btnStyle="simple"
              type="submit"
              block
              style={{
                marginTop: '30px',
                background: '#FAFAFA',
                border: '1px solid #EDE7F6'
              }}
            >
              <img
                src="images/Google.png"
                style={{ width: '24px', height: 'auto' }}
              />{' '}
              Sign In with Google
            </Button> */}
            {/* <Links style={{ marginTop: '-12px', textAlign: 'end' }}>
              <Link to="/otp">{__('Comfirm Email')}</Link>
            </Links> */}
          </div>
        </form>
      </div>
    );
  }

  render() {
    const { __ } = this.context;
    return (
      <div style={{ width: '485px', margin: 'auto' }}>
        <AuthTextBox>
          <h2>{__('Sign in')}</h2>
        </AuthTextBox>
        <AuthBox>{this.renderLoginForm()}</AuthBox>
      </div>
    );
  }
}

LoginFormTheme.propTypes = propTypes;
LoginFormTheme.contextTypes = {
  __: PropTypes.func
};

const stateToProps = state => ({
  currentUser: globalStateSelector.getDynamic(state, { key: 'currentUser' })
});

const dispatchToProps = dispatch => ({
  dynamicUpdate: data => {
    dispatch(globalAction.dynamicUpdate({ data }));
  }
});
export default withRouter(
  connect(stateToProps, dispatchToProps)(LoginFormTheme)
);


// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/LoginFormTheme.js